/** Legacy Trellis credentials using a token pair. */
export interface TrellisLegacyCredentials {
    registrationToken: string;
    authToken: string;
}

export interface TrellisJWTCredentials {
    jwt: string;
}

/** Modern Trellis credentials using a SSO. */
export interface TrellisSSOCredentials {
    sso: string;
}

/** Container for the credentials provided by Trellis. */
export type TrellisCredentials = TrellisLegacyCredentials | TrellisJWTCredentials | TrellisSSOCredentials;

/**
 * Determine whether Trellis credentials are a modern JWT or not.
 * Determine whether Trellis credentials are an SSO token.
 * @param credentials The credentials to examine.
 * @returns True if credentials are a JWT, false otherwise.
 * @returns True if credentials are an SSO token, false otherwise.
 */
export function credentialsAreJwt(credentials: TrellisCredentials): credentials is TrellisJWTCredentials {
    return !!("jwt" in credentials && credentials.jwt);
}

/**
 * Determine whether Trellis credentials are an SSO token.
 * @param credentials The credentials to examine.
 * @returns True if credentials are an SSO token, false otherwise.
 */
export function credentialsAreSSO(credentials: TrellisCredentials): credentials is TrellisSSOCredentials {
    return !!("sso" in credentials && credentials.sso);
}

/** Get credentials provided by Trellis when it launches Payments. */
export function getCredentials(): TrellisCredentials | undefined {
    const queryParams = new URLSearchParams(window.location.search);

    const authToken = queryParams.get("authToken");
    const registrationToken = queryParams.get("registrationToken");
    const jwt = queryParams.get("jwt");
    const sso = queryParams.get("ssotoken");

    if (sso) {
        return {
            sso,
        };
    } else if (jwt) {
        return {
            jwt,
        };
    } else if (authToken && registrationToken) {
        return {
            authToken,
            registrationToken,
        };
    } else {
        return undefined;
    }
}
